module.exports = __webpack_public_path__ + "static/img/badge_sc.54c252e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/badges/badge_sc.svg
// module id = 2674
// module chunks = 0